const config = {
  siteTitle: 'The Best TEFL Courses in Barcelona | Trinity CertTESOL Certification', // Site title.
  siteTitleShort: 'TEFL Iberia', // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: 'TEFL Iberia', // Alternative site title for SEO.
  siteLogo: 'src/assets/images/favicon/favicon.png', // Logo used for SEO and manifest.
  siteFavicon: 'src/assets/images/favicon/favicon.png',
  siteImage: 'https://devhance.co/images/photos/devhance.png',
  siteUrl: 'https://tefl-iberia.com/', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription:
    'The best TEFL courses in Barcelona, Spain, from TEFL Iberia. Apply online. Our 160-hour TEFL course is only €1400 with an early-bird discount!', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml', // Path to the RSS file.
  siteRssTitle: '', // Title of the RSS feed
  siteFBAppID: '', // FB Application ID for using app insights
  googleAnalyticsID: '', // GA tracking ID.
  dateFromFormat: 'YYYY-MM-DD', // Date format used in the frontmatter.
  dateFormat: 'DD/MM/YYYY', // Date format for display.
  userName: 'TEFL Iberia', // Username to display in the author segment.
  userEmail: 'info@tefl-iberia.com', // Email used for RSS feed's author segment
  userTwitter: '@TEFL_Iberia', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'Spain, Barcelona', // User location to display in the author segment.
  userAvatar: 'src/images/favicon/favicon.png', // User avatar to display in the author segment.
  userDescription: '', // User description to display in the author segment.
  themeColor: '#c91c20', // Used for setting manifest and progress theme colors.
  backgroundColor: '#c91c20', // Used for setting manifest background color.
  copyright: 'Copyright © Devhance 2020. All rights reserved.', // Copyright string for the footer of the website and RSS feed.
  locales: ['en'],
  defaultLang: 'en',
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === '/') {
  config.pathPrefix = '';
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, '')}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === '/') config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== '/') config.siteRss = `/${config.siteRss}`;

module.exports = config;
